<template>
  <li class="nav-item dropdown">
    <a
      class="nav-link dropdown-toggle"
      href="javascript:void(0);"
      id="navbar-company-selection"
      role="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      {{
        selected_company == null
          ? 'Selecione uma empresa'
          : selected_company.name
      }}
    </a>
    <div
      class="dropdown-menu"
      aria-labelledby="navbar-company-selection"
      id="companiesDropdownScroll"
    >
      <div class="search">
        <input
          type="text"
          v-model="dropdown_company_filters.name"
          placeholder="Selecione ou pesquise"
        />
      </div>
      <div class="content" @scroll="onCompaniesDropdownScroll">
        <a
          v-for="row in dropdown_companies"
          :key="row.company_id"
          class="dropdown-item"
          href="javascript:void(0);"
          @click.prevent="onSelectCompany(row.company_id)"
          >{{ row.name }}</a
        >

        <div
          class="no-content dropdown-item"
          v-if="dropdown_companies?.length === 0"
        >
          Nenhum resultado encontrado...
        </div>
      </div>
    </div>
  </li>
</template>

<script>
  import { computed, onMounted } from 'vue'
  import { useStore } from 'vuex'
  import useCompaniesDropdown from '@/modules/CompanyDropdown.js'

  export default {
    name: 'App',
    setup() {
      const {
        dropdown_companies,
        dropdown_company_filters,
        onCompaniesDropdownScroll,
        loadNextCompaniesPage,
      } = useCompaniesDropdown(500)

      const store = useStore()

      const selected_company = computed(() => store.getters.selected_company)

      onMounted(() => {
        loadNextCompaniesPage()
      })

      return {
        dropdown_companies,
        dropdown_company_filters,
        onCompaniesDropdownScroll,
        store,
        selected_company,
      }
    },
    methods: {
      async onSelectCompany(company_id) {
        // limpa a pesquisa: ao reabrir a lista, o usuario ja digita o novo nome
        this.dropdown_company_filters.name = ''

        if (this.$route.name !== 'index') {
          await this.$router.replace({ path: '/' })
        }

        this.store.dispatch('selectStandard', null)
        this.store.dispatch('selectOrderOfService', null)
        this.store.dispatch('selectCompany', company_id)
      },
    },
  }
</script>
<style lang="scss" scoped>
  div#companiesDropdownScroll {
    height: auto;
    max-width: 370px;
    min-width: 300px;

    .search {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 10px 24px;

      input {
        width: 100%;
      }
    }

    .content {
      max-height: 300px;
      overflow-y: scroll;
    }
  }
</style>
